<template>
  <button
      class="btn btn--filter"
      @click="toggleMobileFilters"
  >
    <svg class="icon" width="12" height="14.35" viewBox="0 0 12 14.35" aria-hidden="true" focusable="false">
      <defs>
        <clipPath id="e1683037-e1bb-4137-85b0-b7f5fff8c068" transform="translate(0 0)">
          <rect width="12" height="15" fill="none" />
        </clipPath>
      </defs>
      <title>icon-filters</title>
      <g id="b27384fb-048b-46a0-ac42-6bc287a57b04" data-name="filters">
        <g clip-path="url(#e1683037-e1bb-4137-85b0-b7f5fff8c068)">
          <line x1="0.5" y1="2.17" x2="11.5" y2="2.17" fill="none" stroke="#fff" stroke-linecap="round" />
          <line x1="0.5" y1="12.17" x2="11.5" y2="12.17" fill="none" stroke="#fff" stroke-linecap="round" />
          <line x1="0.5" y1="7.17" x2="11.5" y2="7.17" fill="none" stroke="#fff" stroke-linecap="round" />
          <path d="M8.47,4A1.78,1.78,0,1,0,6.69,2.17,1.78,1.78,0,0,0,8.47,4" transform="translate(0 0)"
                fill="#11264b" />
          <circle cx="8.47" cy="2.17" r="1.77" fill="none" stroke="#fff" stroke-width="0.8" />
          <path d="M8.47,14a1.78,1.78,0,1,0-1.78-1.78A1.78,1.78,0,0,0,8.47,14" transform="translate(0 0)"
                fill="#11264b" />
          <circle cx="8.47" cy="12.17" r="1.77" fill="none" stroke="#fff" stroke-width="0.8" />
          <path d="M3.17,9A1.78,1.78,0,1,0,1.4,7.17,1.78,1.78,0,0,0,3.17,9" transform="translate(0 0)" fill="#11264b" />
          <circle cx="3.17" cy="7.17" r="1.77" fill="none" stroke="#fff" stroke-width="0.8" />
        </g>
      </g>
    </svg>
    Filters
  </button>
</template>
<script setup>
const emit = defineEmits( [ 'toggleMobileFilters' ] );
const toggleMobileFilters = () => emit( 'toggleMobileFilters' );
</script>
